export default function getEnv(envName: string) {
  if (process.env.NODE_ENV === 'development') {
    return process.env[envName] ?? '';
  }
  // @ts-expect-error injetado em runtime no build de produção (docker-entrypoint / index)
  return window.prod_env?.[envName] ?? '';
}
